import React from 'react';
import useTMTranslation from '../../../../../../Hooks/useTMTranslation';
import ApplicantInformationType from '../../../../../../Models/ApplicantInformationType';
import PhoneNumberField from './PhoneNumber/PhoneNumberField';

function ApplicantPhoneNumber(): React.JSX.Element {
    const { tCommon: t } = useTMTranslation();
    return <PhoneNumberField label={`${t('PhoneNumber')}*`} name={ApplicantInformationType.PhoneNumber} />;
}

export default ApplicantPhoneNumber;
